import { LinearProgress } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import firebase from 'firebase';
import moment from 'moment';
import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { db, storage } from '../../configs/firebase';
import './ImageUpload.css';

function ImagePost({ displayName }) {
  const [caption, setCaption] = useState('');
  const [progress, setProgress] = useState(0);
  const [image, setImage] = useState(null);
  const [showProgressBar, setShowProgressBar] = useState(false);
  const [coverDragEnter, setCoverDragEnter] = useState(false);

  const handleCoverDragEnter = (e) => {
    e.stopPropagation();
    e.preventDefault();
    setCoverDragEnter(true);
  };
  const handleCoverDragOver = (e) => {
    e.stopPropagation();
    e.preventDefault();
    setCoverDragEnter(true);
  };
  const handleCoverDragLeave = (e) => {
    e.stopPropagation();
    e.preventDefault();
    setCoverDragEnter(false);
  };
  const handleCoverDrop = (e) => {
    e.stopPropagation();
    e.preventDefault();
    setShowProgressBar(true);
    if (e.dataTransfer.files[0]) {
      setImage(e.dataTransfer.files[0]);
    }
  };

  function fileUpload(e) {
    setShowProgressBar(true);
    if (e.target.files[0]) {
      setImage(e.target.files[0]);
    }
  }

  function handleCaption(e) {
    setCaption(e.target.value);
  }

  function handlePost() {
    if (image) {
      const uploadTask = storage.ref(`images/${image.name}`).put(image);

      // getting the upload status while the image is uploading
      uploadTask.on(
        'state_changed',
        (snapshot) => {
          // Progress function
          const progress = Math.round(
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100
          );
          setProgress(progress);
        },
        (error) => {
          // error function
          console.log(error);
        },
        () => {
          // completion function
          storage
            .ref('images')
            .child(image.name)
            .getDownloadURL()
            .then((url) => {
              db.collection('posts').add({
                timestamp: firebase.firestore.FieldValue.serverTimestamp(),
                caption: caption,
                imgUrl: url,
                username: displayName,
                date: moment().format('LLL'),
              });

              setProgress(0);
              setCaption('');
              setImage(null);
              setShowProgressBar(false);
              setCoverDragEnter(false);
            });
        }
      );
    } else {
      toast.error('Please select an image');
    }
  }

  return (
    <div className="image__upload">
      <div className="input__holder">
        <p className="text-base font-body font-semibold tracking-wider text-brand-900">
          Write a caption and post an image to the community
        </p>

        {showProgressBar && (
          <LinearProgress
            variant="determinate"
            className="mt-4"
            value={progress}
            max="100"
          />
        )}
        <TextField
          className="caption__upload"
          onChange={handleCaption}
          value={caption}
          rows={5}
          id="standard-basic"
          label="Write a caption"
        />
        {/* Cover Photo */}

        <div className="mb-5 w-80 sm:w-128">
          <label
            className={`mt-1 flex justify-center px-6 py-12 border-2 ${
              coverDragEnter ? 'border-brand-700' : 'border-gray-300'
            } border-dashed rounded-md`}
            htmlFor="image-cover"
            onDragEnter={handleCoverDragEnter}
            onDragLeave={handleCoverDragLeave}
            onDragOver={handleCoverDragOver}
            onDrop={handleCoverDrop}
          >
            <div className="space-y-1 text-center">
              <svg
                className="mx-auto h-12 w-12 text-gray-400"
                stroke="currentColor"
                fill="none"
                viewBox="0 0 48 48"
                aria-hidden="true"
              >
                <path
                  d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></path>
              </svg>
              <div className="flex text-sm text-gray-700">
                <label
                  htmlFor="image-cover"
                  className="relative cursor-pointer rounded-md font-body font-semibold tracking-wider text-brand-900 hover:text-blue-700 focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-blue-500"
                >
                  <span>Upload image </span>
                  <input
                    onChange={fileUpload}
                    type="file"
                    name="image-cover"
                    id="image-cover"
                    className="sr-only"
                  />
                </label>
                <p className="pl-1 font-semibold tracking-wider font-body">
                  or drag and drop here
                </p>
              </div>
              <p className="text-xs text-gray-600 tracking-wider font-body">
                Only image files are supported
              </p>
            </div>
          </label>
        </div>

        <Button
          className="button__upload"
          onClick={handlePost}
          variant="contained"
          color="primary"
        >
          Post Image
        </Button>
      </div>
    </div>
  );
}

export default ImagePost;
